<template>
  <v-app class="fondo">
    <router-view />
    <div v-if="showCookieBanner" class="cookie-banner">
      <div class="cookie-banner-title">Preferencias de cookies</div>
      <div class="cookie-banner-text">
        Este sitio utiliza cookies para mejorar tu experiencia. Aceptas el uso
        de cookies?
      </div>
      <div class="cookie-banner-actions">
        <v-btn class="cookie-btn cookie-btn--reject" text @click="rejectMarketingCookies"
          >Rechazar</v-btn
        >
        <v-btn class="cookie-btn cookie-btn--accept" color="primary" @click="acceptMarketingCookies">Aceptar</v-btn>
      </div>
    </div>
    <v-snackbar v-model="showSnackbar">
      {{ snackbarMessage }}
      <v-btn dark @click="showSnackbar = false" text>OK</v-btn>
    </v-snackbar>

    <v-alert
      :type="alertType"
      v-model="showAlert"
      :dismissible="true"
      border="left"
      transition="slide-x-reverse-transition"
      >{{ alertMessage }}</v-alert
    >
  </v-app>
</template>

<script>
import { events } from "./main";

export default {
  name: "App",

  data() {
    return {
      snackbarMessage: "",
      showSnackbar: false,
      showCookieBanner: false,
      showAlert: false,
      alertType: "success",
      alertMessage: "",
    };
  },

  methods: {
    hasMarketingConsent() {
      return (
        localStorage.getItem("risoul_cookie_consent_marketing") === "granted"
      );
    },
    hasMarketingDecision() {
      return localStorage.getItem("risoul_cookie_consent_marketing") !== null;
    },
    setMarketingConsent(granted) {
      localStorage.setItem(
        "risoul_cookie_consent_marketing",
        granted ? "granted" : "denied",
      );
      this.showCookieBanner = false;

      if (granted) {
        this.loadHubspotScript();
      }
    },
    acceptMarketingCookies() {
      this.setMarketingConsent(true);
    },
    rejectMarketingCookies() {
      this.setMarketingConsent(false);
    },
    loadHubspotScript() {
      if (document.getElementById("hs-script-loader")) return;

      const hsCounter = document.createElement("script");
      hsCounter.setAttribute("src", "https://js.hs-scripts.com/1842664.js");
      hsCounter.setAttribute("id", "hs-script-loader");
      hsCounter.async = true;
      hsCounter.defer = true;
      document.head.appendChild(hsCounter);
    },
    onCookieConsentUpdated(event) {
      const detail = event && event.detail ? event.detail : {};
      if (typeof detail.marketing !== "boolean") return;
      this.setMarketingConsent(detail.marketing);
    },
    snackbar(message) {
      this.snackbarMessage = message;
      this.showSnackbar = true;
    },
    alert(data) {
      this.alertType = data.type;
      this.alertMessage = data.message;
      this.showAlert = true;
    },
  },

  mounted() {
    events.$on("snackbar", (message) => {
      this.snackbar(message);
    });

    events.$on("alert", (data) => {
      this.alert(data);
    });

    window.addEventListener(
      "risoul-cookie-consent-updated",
      this.onCookieConsentUpdated,
    );

    window.risoulCookieConsent = {
      grantMarketing: () => this.setMarketingConsent(true),
      denyMarketing: () => this.setMarketingConsent(false),
      resetMarketing: () => {
        localStorage.removeItem("risoul_cookie_consent_marketing");
        this.showCookieBanner = true;
      },
    };
  },

  created() {
    if (this.hasMarketingConsent()) {
      this.loadHubspotScript();
    } else if (!this.hasMarketingDecision()) {
      this.showCookieBanner = true;
    }
  },

  beforeDestroy() {
    window.removeEventListener(
      "risoul-cookie-consent-updated",
      this.onCookieConsentUpdated,
    );

    if (
      window.risoulCookieConsent &&
      typeof window.risoulCookieConsent === "object"
    ) {
      delete window.risoulCookieConsent;
    }
  },
};
</script>

<style lang="scss">
html {
  font-size: 62.5%;
}

.fondo {
  background: rgba(245, 243, 243, 0.952) !important;
}

.cookie-banner-title {
  font-size: 1.7rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 6px;
  color: #0f2e68;
}

.cookie-banner-text {
  font-size: 1.45rem;
  line-height: 2.1rem;
  text-align: center;
  margin-bottom: 12px;
  color: #334155;
}

.cookie-banner {
  position: fixed;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);
  z-index: 1000;
  width: calc(100% - 24px);
  max-width: 720px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  color: #1f2937;
  border-radius: 14px !important;
  border: 1px solid #d9e0ea;
  border-top: 4px solid #f16716;
  padding: 14px 20px 16px;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.2);
}

.cookie-banner-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.cookie-btn {
  min-width: 126px !important;
  border-radius: 10px !important;
  font-weight: 700 !important;
  letter-spacing: 0.02em !important;
}

.cookie-btn--reject {
  color: #b42318 !important;
}

@media all and (max-width: 600px) {
  .cookie-banner {
    width: calc(100% - 16px);
    bottom: 8px;
    padding: 12px 14px 14px;
    border-radius: 12px !important;
  }

  .cookie-btn {
    min-width: 112px !important;
  }
}

.v-list-item {
  min-height: 24px !important;
  padding: 0 16px !important;
}

.v-list-item__title {
  font-size: 1.6rem;
}

.v-btn.v-size--small {
  font-size: 1.2rem;
}

.v-card__subtitle,
.v-card__text {
  font-size: 1.4rem;
  line-height: 2.2rem;
}

.v-btn.v-size--default,
.v-btn.v-size--large {
  font-size: 1.4rem;
}

.v-list--dense .v-list-item .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list-item--dense .v-list-item__title {
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 1.6rem;
}

.v-snack__content {
  font-size: 1.4rem;
  line-height: 2rem;
}

.v-pagination__item {
  font-size: 1.6rem;
  margin: 0.5rem;
}

.v-stepper__step__step {
  font-size: 1.2rem;
}

.v-stepper__label {
  font-size: 1.6rem;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 1.2rem;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
  font-size: 1.4rem;
}

.v-data-footer {
  font-size: 1.2rem;
}

.v-data-footer__select .v-select__selections .v-select__selection--comma {
  font-size: 1.2rem;
}

.theme--light.v-list-item:hover:before {
  opacity: 0.2;
}

.theme--light.v-btn:hover:before {
  opacity: 0.1;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 1rem;
}

/* width */
.v-list::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.v-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.v-list::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.v-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>

<style>
* {
  font-family: Roboto, Arial, Helvetica, sans-serif;
}

div[tabindex] {
  outline: none;
}

.cursor-pointer {
  cursor: pointer;
}

.v-list__tile {
  font-size: 12px;
}

.custom-title {
  color: #000000;
  font-size: 25px;
  font-weight: bold !important;
}

.action-table-btns {
  display: flex;
  justify-content: center;
}

.delete-dialog .headline {
  justify-content: center;
  font-weight: 700;
}

.delete-dialog .text {
  padding: 20px 0 25px;
}

.delete-dialog .text .v-card__text {
  padding: 0;
}

.delete-dialog .v-card {
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.delete-dialog .v-card .v-card__actions {
  display: flex;
  width: 100%;
  justify-content: space-around;
}

table > tbody > tr > td {
  white-space: nowrap;
}

table > tbody > tr > td > i.v-icon.v-icon--link {
  margin: 0px 10px;
}

.tab-text {
  color: #85200c !important;
  font-weight: bold;
}

.many-to-one-grid {
  z-index: 1;
}

.many-to-one-input-container {
  display: flex;
  align-items: center;
}

.dialog-input input {
  cursor: pointer;
}

.toolbar-form > div {
  align-items: flex-end;
}

.toolbar-form > div > div,
.toolbar-form > div > button {
  margin-bottom: 13px;
}

.workflow-buttons-group {
  border-radius: 5px;
  padding: 5px;
  margin-left: 6px;
  display: inline-block;
  margin-left: auto;
  margin-right: 0px;
  display: block;
}

.workflow-buttons-group {
  border-radius: 5px;
  padding: 5px;
  margin-left: 6px;
}

.workflow-state-form {
  text-align: right;
}

.workflow-state-form > div {
  width: 20%;
  display: inline-flex;
  min-width: 200px;
}

.filter-button {
  margin: 20px;
  text-decoration: underline;
  color: dodgerblue;
}

.filter-button i {
  font-size: 12px !important;
  color: inherit !important;
  display: inline-block;
}

.text.divider-container {
  display: flex;
  background-color: var(--v-secondary-lighten5);
  color: var(--v-secondary-lighten1);
  max-width: max-content;
  padding: 0px 15px;
  font-size: 12px;
  align-self: baseline;
}

.text.divider-container > div {
  margin: auto;
}

hr.divider-container {
  border-color: var(--v-secondary-lighten5) !important;
}

.grid-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Grid layout styles */
.grid-container {
  display: grid;
  grid-auto-flow: row;
  justify-items: stretch;
  align-items: stretch;
  padding: 10px 0;
}

.grid-container .wrapper-special {
  text-align: center;
}
.grid-container .wrapper-special:empty {
  display: none;
}

.creation-info-wrapper {
  color: #a2a2a2;
  padding: 5px;
  display: flex;
  flex-direction: column;
}

.creation-info-wrapper > span {
  text-align: center;
  color: #a2a2a2;
}

.currency-input-wrapper,
.percentage-input-wrapper,
.decimal-input-wrapper {
  display: flex;
  flex-direction: row-reverse;
}

.currency-input-wrapper input,
.percentage-input-wrapper input,
.decimal-input-wrapper input {
  text-align: right;
}

.currency-input-wrapper > div.label-prepend,
.percentage-input-wrapper > div.label-prepend,
.decimal-input-wrapper > div.label-prepend {
  font-size: 12px;
  min-width: 125px;
  max-width: 125px;
  text-align: right;
  display: inline-block;
  margin-bottom: auto;
  margin-top: auto;
  -webkit-transition: all 0.2s ease 0s;
  transition: all 0.2s ease 0s;
  margin-right: 9px;
}

.currency-input-wrapper > .error--text + div.label-prepend,
.percentage-input-wrapper > .error--text + div.label-prepend,
.decimal-input-wrapper > .error--text + div.label-prepend {
  color: var(--v-error-base) !important;
  caret-color: var(--v-error-base) !important;
}

.children-title,
.relationship-title {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 10px;
}

.children-title > div,
.relationship-title > div {
  display: flex;
  align-items: center;
  width: 100%;
}

.v-input__control > .v-input__slot > .v-label {
  font-size: 12px !important;
}

@media all and (max-width: 1170px) {
  .grid-container {
    grid-template-columns: 100% !important;
  }
  .grid-container * {
    grid-column: span 1 !important;
    grid-row: span 1 !important;
  }
}

button:not(.v-btn--icon):not(.v-btn--text):not(.v-btn--floating).v-btn.saveBtn {
  border-radius: 3px;
  width: 110px;
  height: 36px;
}

button:not(.v-btn--icon):not(.v-btn--text):not(.v-btn--floating).v-btn.backBtn {
  border-radius: 3px;
  width: 110px;
  height: 36px;
}

.v-content .v-toolbar__content {
  padding: 0;
}

.v-list__tile {
  height: 38px !important;
}

.theme--light.v-datatable tr:not(.v-datatable__progress) th {
  background-color: #f16716;
  color: #ffffff !important;
  font-weight: bold;
}

/* Classics styles */
.back-icon {
  font-weight: 800;
  color: var(--v-secondary-darken4);
  color: #000000 !important;
}

.form-actions-container {
  text-align: center;
}

.form-actions-container button {
  width: 180px !important;
  margin: 15px;
}

.v-input--switch:focus {
  outline-color: transparent;
}

.v-picker .v-picker__body .v-date-picker-table--month button {
  max-width: 160px !important;
  min-width: 40px !important;
  width: 100% !important;
  height: 40px !important;
}

button.v-btn {
  text-transform: none;
}

.classic-button-icon i {
  margin-right: 10px;
}

.classic-text-field.v-text-field > .v-input__control,
.classic-select-field.v-text-field > .v-input__control,
.classic-dialog-input.v-text-field > .v-input__control,
.classic-date-input .v-text-field > .v-input__control {
  margin-top: auto;
  margin-bottom: auto;
  height: inherit;
}

.classic-text-field.v-text-field > .v-input__control > .v-input__slot,
.classic-select-field.v-text-field > .v-input__control > .v-input__slot,
.classic-dialog-input.v-text-field > .v-input__control > .v-input__slot,
.classic-date-input .v-text-field > .v-input__control > .v-input__slot {
  margin-bottom: 0px;
}

.classic-text-field.v-text-field > .v-input__control > .v-input__slot:before,
.classic-text-field.v-text-field > .v-input__control > .v-input__slot:after,
.classic-select-field.v-text-field > .v-input__control > .v-input__slot:before,
.classic-select-field.v-text-field > .v-input__control > .v-input__slot:after,
.classic-dialog-input.v-text-field > .v-input__control > .v-input__slot:before,
.classic-dialog-input.v-text-field > .v-input__control > .v-input__slot:after,
.classic-date-input .v-text-field > .v-input__control > .v-input__slot:before,
.classic-date-input .v-text-field > .v-input__control > .v-input__slot:after {
  content: none;
}

.classic-text-field.v-input,
.classic-select-field.v-text-field,
.classic-dialog-input.v-text-field,
.classic-date-input .v-text-field {
  align-items: baseline;
  margin-top: unset;
  padding-top: unset;
  height: min-content;
}

.classic-text-field.v-text-field .v-text-field__slot,
.classic-text-field .v-text-field__slot {
  border-radius: 5px;
  border-style: solid;
  border-width: 1px;
  border-color: #dedede;
  background-color: #ffffff;
  padding: 8px 10px 8px !important;
  max-height: none !important;
}

.classic-text-field.v-textarea .v-text-field__slot {
  height: inherit;
}

.classic-text-field textarea {
  height: inherit;
}

.classic-text-field:not(.v-textarea) .v-text-field__slot {
  height: 40px;
}

.classic-text-field .v-text-field__slot:focus-within,
.classic-text-field .v-text-field__slot:focus-within {
  background-color: #fff8cc;
  border-color: #ffcc00;
}

.classic-text-field .v-text-field__slot:has(input[disabled="disabled"]),
.classic-text-field .v-text-field__slot:has(textarea[disabled="disabled"]) {
  background-color: #f2f4f7;
  border-color: #dedede;
}

.classic-dialog-input.v-input--is-disabled,
.classic-dialog-input.v-input--is-disabled input,
.classic-date-input .v-input--is-disabled,
.classic-date-input .v-input--is-disabled input {
  cursor: default;
}

.classic-dialog-input.v-input--is-disabled .v-input__slot,
.classic-date-input .v-input--is-disabled .v-input__slot {
  background-color: #f2f4f7;
  border-color: #dedede;
}

.classic-date-input .prepend-label {
  min-width: 125px;
  max-width: 125px;
  color: black !important;
}

.classic-text-field .v-input__prepend-outer,
.classic-select-field .v-input__prepend-outer,
.classic-dialog-input .v-input__prepend-outer {
  color: black !important;
}

.classic-text-field .v-input__prepend-outer > span,
.classic-select-field .v-input__prepend-outer > span,
.classic-dialog-input .v-input__prepend-outer > span,
.classic-date-input .prepend-label > span {
  color: var(--v-error-base);
}

.classic-text-field.error--text .v-input__prepend-outer,
.classic-select-field.error--text .v-input__prepend-outer,
.classic-dialog-input.error--text .v-input__prepend-outer {
  color: var(--v-error-base) !important;
}

.classic-text-field .v-text-field__details,
.classic-select-field .v-text-field__details,
.classic-dialog-input .v-text-field__details,
.classic-date-input .v-text-field__details {
  display: none;
}

.classic-date-input .prepend-label {
  font-size: 12px;
}

.classic-select-field.v-select .v-select__slot,
.classic-dialog-input .v-input__slot,
.classic-date-input .v-input__slot {
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #dedede;
  height: 40px;
  padding-left: 10px;
  background-color: #ffffff;
}

.classic-select-field.v-select .v-select__slot:focus-within,
.classic-dialog-input .v-input__slot:focus-within,
.classic-date-input .v-input__slot:focus-within {
  border-color: #6c0d2b;
}

.classic-select-field.v-select.v-input--is-disabled .v-select__slot,
.classic-dialog-input.v-select.v-input--is-disabled .v-select__slot,
.classic-date-input .v-select.v-input--is-disabled .v-select__slot {
  background-color: #f2f4f7;
  border-color: #dedede;
}

.classic-select-field .v-input__control,
.classic-dialog-input .v-input__control,
.classic-date-input .v-input__control {
  width: calc(100% - 125px);
}

.classic-select-field .v-select__selections,
.classic-dialog-input .v-select__selections,
.classic-date-input .v-select__selections {
  width: calc(100% - 35px);
}

.classic-select-field .v-select__selection,
.classic-dialog-input .v-select__selection,
.classic-date-input .v-select__selection {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.classic-select-field.v-text-field .v-input__append-inner,
.classic-dialog-input.v-text-field .v-input__append-inner,
.classic-date-input .v-text-field .v-input__append-inner {
  align-self: center;
}

.classic-date-input .v-text-field .v-input__append-inner {
  padding-right: 4px;
  margin-top: 0;
}

.classic-select-field.v-text-field .v-input__append-inner i,
.classic-dialog-input.v-text-field .v-input__append-inner i,
.classic-date-input .v-text-field .v-input__append-inner i {
  color: #3a4151 !important;
}

.classic-table table {
  background-color: #ffffff;
  border-style: solid;
  border-width: 1px;
  border-color: #e0e0e0;
}

.classic-table table.v-table tbody td,
.classic-table table.v-table th,
.classic-table table.v-table thead tr {
  height: 30px;
  font-size: 12px;
}

.classic-table .v-expansion-panel__header {
  min-height: 30px;
  height: 30px;
}

.v-input--checkbox,
.v-input--switch {
  height: 100%;
  align-items: center;
  justify-content: flex-end;
  margin-top: unset;
  padding-top: unset;
}

.v-input--checkbox:focus,
.v-input--switch:focus {
  outline: none;
}
.form-inline {
  display: flex;
  flex-flow: row wrap;
}
</style>
